import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Output,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';

import {TableChildDirective} from './table-child.directive';
import {DOCUMENT} from "@angular/common";
import {IntTableHeadOrder, TableData} from "../../types";
import {IntRunNextTickService} from "../../services";

@Component({
  selector: 'int-table, [int-table]',
  templateUrl: './int-table.component.html',
  styleUrls: ['./int-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    IntRunNextTickService
  ]
})
export class IntTableComponent implements AfterViewInit, OnChanges, AfterViewChecked {

  @Input() tableData: TableData[] = [];
  @Input() tableColsOrder: Array<IntTableHeadOrder> = [];
  @Input() headAlign = 'left';
  @Input() bodyAlign = 'left';

  @Input() mode = 'default';

  @Input() tableLayout = 'auto';

  @Input() selectedRows: Set<string> = new Set();
  @Input() selectedFieldSign: string = '';

  @Output() onRowClickEmitter = new EventEmitter<any>();
  @Output() onRowDeleteEmitter = new EventEmitter<any>();
  @Output() onHeadCellClick = new EventEmitter<any>();
  @Output() onHeadRightClick = new EventEmitter();

  @ContentChildren(TableChildDirective) elsList: QueryList<TableChildDirective> | undefined;

  @ViewChild('thead') private readonly thead!: ElementRef | undefined;
  @ViewChild('thc') private readonly thc!: ElementRef | undefined;
  @ViewChild('tableEl') private readonly tableEl!: ElementRef | undefined;

  templates: {[key: string]: TemplateRef<any>} = {} as {[key: string]: TemplateRef<any>};

  tableBodyData: Array<any> = []

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private readonly documentRef: Document,
    private readonly cdr: ChangeDetectorRef,
    private readonly elementRef: ElementRef
  ) {}

  onHeadRightClickHandle(e: Event) {
    e.preventDefault();
    // @ts-ignore
    this.onHeadRightClick.emit({top: e.clientY, left: e.pageX});
  }

  templateNameList(): { [key: string]: TemplateRef<any> } {
    if (this.elsList != null) {
      const template: { [key: string]: any } = {};
      for (const el of this.elsList.toArray()) {
        if (typeof el.type === 'string') {
          template[el.type] = el.templateRef;
        } else {
          el.type.forEach(type => {
            template[type] = el.templateRef;
          })
        }
      }
      return template;
    } else {
      return {};
    }
  }

  getTableBody(): any[] {
    return this.tableData.map((row: { [x: string]: any; }) => {
      return this.tableColsOrder.map(ordered => {
        return {
          content: row[ordered.fieldName] || '',
          fieldName: ordered.fieldName,
          data: row
        };
      });
    });
  }

  str(data: any): string  {
    return JSON.stringify(data);
  }
  isRowSelected(row: Array<any>): boolean {
    const dataByFieldSign = row.find((col) => {
      return col.fieldName === this.selectedFieldSign;
    });
    if(dataByFieldSign) {
      return this.selectedRows.has(dataByFieldSign.data[this.selectedFieldSign]);
    }else{
      return false;
    }
  }

  onRowClick(row: {content: string; fieldName: string; data: any}[]): void {
    this.onRowClickEmitter.emit(row);
  }

  onHeaderCellClick(item: any) {
    this.onHeadCellClick.emit(item);
  }

  private setTheadPlugSize(): void {
      setTimeout(() => {
        if(this.tableEl && this.thead) {
          const { width: headWidth } = this.tableEl.nativeElement?.getBoundingClientRect();
          const { width } = this.elementRef.nativeElement?.getBoundingClientRect();
          this.renderer.setStyle(this.thc?.nativeElement, 'width', `${Math.max(width, headWidth)}px`)
        }
      }, 0)
  }

  _render() {
    console.log('render')
  }

  @HostListener('window:resize')
  resize() {
    this.setTheadPlugSize();
  }

  ngOnChanges(changes: any) {
    this.tableBodyData = this.getTableBody();
  }

  ngAfterViewInit(): void {
    this.templates = this.templateNameList();
    this.tableBodyData = this.getTableBody();
    this.setTheadPlugSize();
    this.cdr.detectChanges();
  }

  ngAfterViewChecked() {
    this.setTheadPlugSize();
  }
}
